import { FormattedMessage, useIntl } from 'react-intl'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Section from 'components/shared/Section'
import {
    UNLIMITED_1ST_RENEW_REGULATIONS_LINK,
    UNLIMITED_2ND_RENEW_REGULATIONS_LINK,
} from 'constants/links'
import { ImageWrapper, Wrapper } from './styles'
import DocsIcon from 'assets/images/unlimitedCard/docs.svg'
import UnlimitedAdvantages from 'components/global/UnlimitedAdvantages'
import { CardEditionType } from 'store/api-slice/types'
import { useMemo } from 'react'

interface RenewInfoBoxProps {
    cardEdition: CardEditionType
    isCompact?: boolean
}

const RenewInfoBox = ({ isCompact, cardEdition }: RenewInfoBoxProps) => {
    const { formatMessage } = useIntl()

    const header = useMemo(() => {
        const textTransformations = {
            strong: (chunks: string[]) => (
                <>
                    <Text as="span" variant="heading2" color="primary_500">
                        {chunks}
                    </Text>
                </>
            ),
        }
        const infoHeaderBlue = formatMessage(
            {
                id: 'annual.renew.info_header_blue',
                defaultMessage:
                    'Zostań z nami! Zamów kartę <strong>Unlimited Blue</strong> w pakiecie z <strong>voucherem kwotowym na 10%</strong> ceny karty i zyskaj dodatkowe korzyści!',
            },
            textTransformations
        )
        const infoHeaderRed = formatMessage(
            {
                id: 'annual.renew.info_header_red',
                defaultMessage:
                    'Zostań z nami! Zamów kartę <strong>Unlimited Blue</strong> w pakiecie z <strong>voucherem kwotowym na 10%</strong> ceny karty i zyskaj dodatkowe korzyści!',
            },
            textTransformations
        )

        switch (cardEdition) {
            case 'blue':
                return infoHeaderBlue
            case 'red':
                return infoHeaderRed
            default:
                return ''
        }
    }, [cardEdition])

    const regulationsLink =
        cardEdition === 'red'
            ? UNLIMITED_2ND_RENEW_REGULATIONS_LINK
            : UNLIMITED_1ST_RENEW_REGULATIONS_LINK

    return isCompact ? (
        <Wrapper>
            <UnlimitedAdvantages cardEdition={cardEdition} />
        </Wrapper>
    ) : (
        <Section>
            <Wrapper gap={32}>
                <ImageWrapper
                    cardEdition={cardEdition}
                    alt={formatMessage({
                        id: 'annual.renew.info_alt',
                        defaultMessage:
                            'Przykładowe karty Unlimited na tle palm',
                    })}
                />
                <Text variant="heading2" color="secondary_500" align="left">
                    {header}
                </Text>
                <UnlimitedAdvantages cardEdition={cardEdition} />
                <Box direction="row" align="center" gap={[10, 12]}>
                    <img src={DocsIcon} alt="" aria-hidden="true" />
                    <Text
                        as="a"
                        href={regulationsLink}
                        target="_blank"
                        variant="bodyStrong"
                        color="secondary_500"
                        data-testid="renew-info-redirect-unlimited-regulations"
                    >
                        <FormattedMessage
                            id="annual.renew.offer_rules"
                            defaultMessage="Zobacz zasady oferty"
                        />
                    </Text>
                </Box>
            </Wrapper>
        </Section>
    )
}

export default RenewInfoBox
